// extracted by mini-css-extract-plugin
module.exports = {"container":"Stat_container__QeJOu","label":"Stat_label__w7UV8","value":"Stat_value__BwUrk","big":"Stat_big__K1s4d"};